import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  checkApprovedCatalogue,
  convertTo12HourFormat,
  handleDateSetUp,
  NoItemsLeftInTable,
} from "../../../../../helpers/helpers";
import { EventAuction } from "../../../../../redux/action/auctionEvent";
import Paginations from "../../../../commanPage/pagination/Paginations";
import useFilteredEvents from "../../../../../helpers/filterEvents";
import CommonTableLoader from "../../../../loader/CommonTableLoader";
import { downloadCateloguePdf } from "../../../../../redux/action/catalogue";

function AllAuctionTable({ searchTraderList, auctionFilter }) {
  const totalNumberRow = 30;
  const navigate = useNavigate();
  const isLaptop = useMediaQuery({ query: "(max-width: 1550px)" });
  const isSmallLaptop = useMediaQuery({ query: "(max-width: 1300px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [allAuctionCollection, setAllAuctionCollection] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageVisited, setMaxPageVisited] = useState(1);
  const dispatch = useDispatch();
  const [initialAllAuctionData, setInitialAllAuctionData] = useState([]);
  const { eventAuctionData } = useSelector((pre) => pre.eventAuction);
  const { loading } = useSelector((pre) => pre.loading);
  const filteredEvents = useFilteredEvents(
    initialAllAuctionData,
    searchTraderList
  );

  useEffect(() => {
    dispatch(EventAuction(currentPage, totalNumberRow, auctionFilter));
  }, [dispatch, auctionFilter, currentPage]);

  useEffect(() => {
    setAllAuctionCollection(eventAuctionData);
    setInitialAllAuctionData(eventAuctionData);
  }, [eventAuctionData]);

  const memoizedBuyerAllAuction = useMemo(
    () => allAuctionCollection,
    [allAuctionCollection]
  );

  useEffect(() => {
    setAllAuctionCollection(filteredEvents);
  }, [filteredEvents]);

  useEffect(() => {
    setMaxPageVisited(1);
    setCurrentPage(1);
  }, [auctionFilter]);

  if (loading) {
    return <CommonTableLoader />;
  }

  return (
    <>
      <div className={`${!isTablet && "table-container-style"}`}>
        {memoizedBuyerAllAuction?.length <= 0 && searchTraderList !== "" ? (
          <NoItemsLeftInTable />
        ) : (
          <table
            className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
              } `}
          >
            <thead>
              <tr>
                <th>Auction ID</th>
                <th>Auction Region</th>
                <th>Description</th>
                <th>Date/Time</th>
                <th style={{ width: isLaptop && "90px" }}>Catalogue</th>
              </tr>
            </thead>
            <tbody>
              {memoizedBuyerAllAuction?.map((items) => (
                <tr
                  key={items._id}
                  className="pointer tableRow-hover"
                  onClick={() => {
                    if (items?.auctionType === "reverseAuctionProduct") {
                      navigate(
                        `/reverse-product-auction/auction-details/${items?._id}`
                      );
                    } else if (
                      items?.auctionType === "reverseAuctionService"
                    ) {
                      navigate(
                        `/reverse-service-auction/auction-details/${items?._id}`
                      );
                    } else {
                      navigate(`/forward-auction/auction-details/${items?._id}`);
                    }
                  }}
                >
                  <td style={{ width: isLaptop && "270px" }}>
                    <span
                      className={`${!isSmallLaptop ? "valign-wrapper justify-center" : ""
                        }`}
                    >
                      <span>{items?.auctionId}</span>
                      <p>
                        {items?.location?.state && !isSmallLaptop
                          ? ` - ${items.location.state}`
                          : items.location.state}
                      </p>
                    </span>

                  </td>
                  <td>{items?.auctionRegion || "..."}</td>
                  <td
                    className=""
                    style={{ width: isLaptop ? "200px" : "300px" }}
                  >
                    <p
                      className="NoOfline flex justify-center"
                      style={{ WebkitLineClamp: 1 }}
                    >
                      {items.description}
                    </p>
                  </td>

                  <td>
                    <spn
                      className={`${isLaptop ? "" : "valign-wrapper justify-center"
                        }`}
                      style={{ gap: "4px" }}
                    >
                      <p>
                        {`${handleDateSetUp(
                          items?.auctionSchedule?.startDate
                        )},`}{" "}
                      </p>
                      <p>
                        {convertTo12HourFormat(
                          items?.auctionSchedule?.startingTime
                        )}{" "}
                        to{" "}
                        {convertTo12HourFormat(
                          items?.auctionSchedule?.endingTime
                        )}
                      </p>
                    </spn>
                  </td>
                  <td>
                    <button
                      className={`${!checkApprovedCatalogue(
                        items?.catalogue?.industryApproval?.status
                      )
                        ? "zoom-icon"
                        : ""
                        } pointer`}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (
                          items?.catalogue?.industryApproval?.status ===
                          "approval"
                        ) {
                          dispatch(downloadCateloguePdf(items?.catalogue?._id));
                        }
                      }}
                      data-tooltip-id={
                        checkApprovedCatalogue(
                          items?.catalogue?.industryApproval?.status
                        )
                          ? "view-catalogue"
                          : ""
                      }
                    >
                      <span className="material-symbols-outlined">
                        download
                      </span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {memoizedBuyerAllAuction?.length === 0 && searchTraderList === "" && (
          <NoItemsLeftInTable />
        )}
      </div>

      {memoizedBuyerAllAuction?.length !== 0 && (
        <Paginations
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalNumberRow={totalNumberRow}
          totalData={eventAuctionData?.length}
          maxPageVisited={maxPageVisited}
          setMaxPageVisited={setMaxPageVisited}
        />
      )}
      <ReactTooltip
        id={`view-catalogue`}
        content={
          <p className="textAlign-center" style={{ width: "160px" }}>
            Please wait for catalogue approval
          </p>
        }
      />
    </>
  );
}

export default AllAuctionTable;
